import { StoreEnhancer, applyMiddleware, compose, createStore } from "redux";
import { persistCombineReducers, persistStore } from "redux-persist";

import localforage from "localforage";
import reducers from "./reducers";
import thunk from "redux-thunk";

const createLocalStore = async () => {
  // configure persistence
  const persistConfig = {
    key: "signal",
    version: 1.0,
    blacklist: [""],
    storage: localforage,
  };

  type WindowWithDevTools = Window & {
    __REDUX_DEVTOOLS_EXTENSION__: () => StoreEnhancer<unknown, {}>;
  };

  const composeEnhancers =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  // create reducer
  const persistedReducer = persistCombineReducers(persistConfig, reducers);

  // create store, with persistence
  return new Promise((resolve) => {
    // @ts-ignore
    const reduxStore = createStore(
      persistedReducer,
      composeEnhancers(applyMiddleware(thunk))
    );
    persistStore(reduxStore, {}, () => resolve(reduxStore));
  });
};

export default createLocalStore;
